import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';

export default function NewsHighlights() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
        <div className="lg:w-2/3">
          <div className="flex items-center justify-between mb-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">热门资讯精选</h2>
            <Link to="/news" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap">
              查看更多 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
          <div className="space-y-4">
            {newsList.slice(0, 2).map((item) => (
              <Link
                key={item.id}
                to={`/news/${item.id}`}
                className="group flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200/70 hover:border-primary-300 rounded-lg overflow-hidden p-3 sm:p-4 transition-colors cursor-pointer"
              >
                <div className="w-full sm:w-56 h-40 sm:h-32 shrink-0 rounded-md overflow-hidden">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} 泰坦尼克号`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex flex-col justify-center">
                  <span className="text-xs text-secondary-600 font-medium mb-1">{item.category}</span>
                  <h3 className="font-semibold text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="lg:w-1/3">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">更多资讯动态</h2>
          <ul className="divide-y divide-background-200/70 bg-background-50 border border-background-200/70 rounded-lg">
            {newsList.slice(2, 6).map((item) => (
              <li key={item.id}>
                <Link
                  to={`/news/${item.id}`}
                  className="flex items-start justify-between gap-3 px-4 py-3.5 hover:bg-background-100/70 cursor-pointer transition-colors"
                >
                  <span className="text-sm text-foreground-800 line-clamp-2">{item.title}</span>
                  <span className="text-xs text-foreground-400 shrink-0 whitespace-nowrap">{item.date.slice(5)}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}